export enum ProjectActions {
	build = "build",
	deploy = "deploy",
	manualRun = "manualRun",
}
